export const ANNOTATION_DRAG_THRESHOLD = 10;
export const DEMO_MICRO_CONFERENCE_TOKEN = 'tok_IiaOz2Lxf7pgXAFYcZSkazOQKQfH1bj2t3uZPvhhAim';
